module.exports = __webpack_public_path__ + "static/media/nucleo-icons.2569aaea.woff";